import { useQuery } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { apiClient, ArrayWithTotal, Entity } from '../api';

export const useEntitiesStore = defineStore(
    'entities',
    () => {
        const query = useQuery({
            queryKey: ['entities'],
            queryFn: () => apiClient.entities.$get([{ key: 'limit', value: '999' }]),
            initialData: [] as unknown as ArrayWithTotal<Entity>,
        });

        const entities = computed(() => query.data.value);
        const total = computed(() => entities.value.total ?? 0);
        const isFetching = computed(() => query.isFetching.value);
        const isError = computed(() => query.isError.value);

        const createEntity = async (info: { name: string; number: string }) => {
            const entity = await apiClient.entities.$post({
                name: info.name,
                registration_number: info.number,
                registered_country: 'NL',
            });

            await query.refetch();

            return entity;
        };

        return {
            entities,
            total,
            isFetching,
            isError,
            // Actions
            createEntity,
        };
    },
    { persistedState: { persist: true } },
);
